import { Cesium3DTileFeature, defined, KeyboardEventModifier, ScreenSpaceEventHandler, ScreenSpaceEventType } from "cesium";
import { DialogGeneral } from "../utils/Dialog/dialog";
import { colorIsolateCesium, createUUID } from "../utils/utils";
import '../styles/dataProperties.css'
import { getMessage } from "../language";
import { IconArrowTriangle } from "../icon";
import loadingGif from "../assets/images/loading-roll-2.png";
import { InputDataPrimitive } from "./styleElement";
interface dataElement {
    name: string;
    value: string;
}


export class DataPropeties {
    viewer: any;
    containerId: string;
    IdGenneral = createUUID();//Tạo ID ngẫu nhiên khi khởi tạ
    modal: any
    private _token = ''
    private dialog: DialogGeneral | undefined;
    private _isOpenModal = false
    // Thuộc tính để lưu callback
    private onClosedCallback: ((status: boolean) => void) | undefined;
    private listPicked: any[] = []; // Mảng để lưu các đối tượng đã chọn

    private handler: any
    objs: dataElement[] = [];
    inputObjPrimitive: InputDataPrimitive | undefined

    constructor(containerId: string, viewer: any, token: string) {
        this._token = token
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.createModalDataElement()
        this.dialog?.showModal(false)
        this.pickDataElement()
    }

    // Gán callback từ lớp cha
    setClosedCallback(callback: (status: boolean) => void): void {
        this.onClosedCallback = callback;
    }
    // Gọi callback để thông báo thay đổi trạng thái
    notifyCallBack(status: boolean): void {
        if (this.onClosedCallback) {
            this.onClosedCallback(status); // Thông báo cho lớp cha
            if (!status) {

                // this.removeAllClickEvents();
            }
        } else {
            console.error("State change callback is not set.");
        }
    }


    createModalDataElement = () => {
        this.dialog = new DialogGeneral(
            this.containerId,
            this.handleCloseModal
        );
        this.dialog.innerHeader = getMessage("element-properties-title-dialog");
        this.dialog.modal = false
        this.dialog.minimizeDialog = true;
        this.dialog.widthModal = "300px"
        this.dialog.heightModal = "500px"
        this.dialog.innerBody = this.renderTableData();
        this.dialog.rightModal = '42px'
        this.dialog.topModal = '5px'
        this.dialog.createDialog();
    }




    showHideModalDataElement = (show: boolean) => {

        if (show) {
            this._isOpenModal = true
            this.renderTableData()
        } else {
            this._isOpenModal = false

        }
        this.dialog?.showModal(show)


    }

    private handleCloseModal = (status: boolean) => {
        if (!status) {
            this.notifyCallBack(status)

        }
    }
    private containerDiv: HTMLDivElement | undefined
    //#region  renderTableData
    private renderTableData = () => {
        if (this.containerDiv) {
            this.clearContainer()
        } else {
            this.containerDiv = document.createElement('div')
            this.containerDiv.className = 'dpu-table-container';

        }


        if (!this.objs || this.objs.length === 0 || this._isCtrlLick) {
            // Trường hợp không có dữ liệu
            const noDataDiv = document.createElement('div');
            noDataDiv.className = 'no-data';
            noDataDiv.textContent = getMessage("noData");
            this.containerDiv.appendChild(noDataDiv);
            return this.containerDiv;
        }
        const primitiveValue = this.objs.find(item => item.name === "Primitive")?.value;
        const objPrimitive = this.inputObjPrimitive?.ObjDataPrimitive.find(item => item.data?.folder === primitiveValue)
        const guidValue = this.objs.find(item => item.name === "Guid")?.value;
        if (this._isOpenModal) {
            // Lọc giá trị của "Primitive" và "Guid"
            this._handleCallApi(objPrimitive?.data?.fileKey ?? primitiveValue, guidValue)
        }


        return this.containerDiv
    }
    //#region renderLoading
    private renderLoading = () => {

        if (!this.containerDiv) return
        const containerLoading = document.createElement('div');
        containerLoading.className = 'loading-container';
        containerLoading.style.width = "100%"
        containerLoading.style.height = "100%"
        containerLoading.style.display = "flex"
        containerLoading.style.justifyContent = "center"
        containerLoading.style.alignItems = "center"
        containerLoading.innerHTML = `
                <img src="${loadingGif}" alt="Loading..." width="30" height ="30" />
            `
        this.containerDiv.appendChild(containerLoading)


    }
    //#region renderOldTableData
    private renderOldTableData = () => {
        if (this.containerDiv) {
            this.clearContainer()
        } else {
            this.containerDiv = document.createElement('div')
            this.containerDiv.className = 'dpu-table-container';
        }


        if (!this.objs || this.objs.length === 0 || this._isCtrlLick) {
            // Trường hợp không có dữ liệu
            const noDataDiv = document.createElement('div');
            noDataDiv.className = 'no-data';
            noDataDiv.textContent = getMessage("noData");
            this.containerDiv.appendChild(noDataDiv);
            return this.containerDiv;
        }

        // Tạo bảng
        const table = document.createElement('table');
        table.className = 'info-table';

        // Tạo tbody
        const tbody = document.createElement('tbody');

        // Duyệt qua dữ liệu và thêm các hàng
        this.objs.forEach((item: dataElement) => {
            if (
                item.name !== 'Filename' &&
                item.name !== 'BatchId' &&
                item.name !== 'Material' &&
                item.name !== 'Primitive'
            ) {
                const row = document.createElement('tr');

                // Cột key
                const keyCell = document.createElement('td');
                keyCell.className = 'key';
                keyCell.textContent = item.name;
                row.appendChild(keyCell);

                // Cột value
                const valueCell = document.createElement('td');
                valueCell.className = 'value';
                valueCell.textContent = item.value;
                row.appendChild(valueCell);

                // Thêm hàng vào tbody
                tbody.appendChild(row);
            }
        });

        // Gắn tbody vào bảng
        table.appendChild(tbody);

        // Gắn bảng vào container
        this.containerDiv.appendChild(table);


        return this.containerDiv
    }

    //#region removeLoading
    private removeLoading = () => {
        if (!this.containerDiv) return
        const loadingDiv = this.containerDiv.querySelector('.loading-container');
        if (loadingDiv) {
            this.containerDiv.removeChild(loadingDiv);
        }
    }
    //#region   clearContainer

    private clearContainer = () => {
        if (this.containerDiv) {
            while (this.containerDiv.firstChild) {
                this.containerDiv.removeChild(this.containerDiv.firstChild);
            }
        }
    }
    //#region  _handleCallApi
    private _handleCallApi = async (primitiveValue?: string, guidValue?: string) => {

        if (!primitiveValue || !guidValue) return
        this.renderLoading()
        const response = await fetch(
            `https://translateservicedev.corebim.com/queryTranslateApi/Translate/GetMetadataById?primitive=${primitiveValue}&objId=${guidValue}`,
            {
                method: "GET",
                headers: {
                    "accept": "*/*",
                    "Authorization": `Bearer ${this._token}`,
                },
            }
        );
        if (!response.ok) {
            throw new Error(`API trả về lỗi: ${response.status} - ${response.statusText}`);
        }

        const result = await response.json();
        if (result.statusCode == 200) {
            this.clearContainer()
            result.data.propertySets.forEach((item: any) => {
                this._createRowTable(item)
            })
        } else {
            this.renderOldTableData()
        }
        this.removeLoading()
    }

    private _createRowTable = (obj: any) => {
        if (!this.containerDiv) return
        // this.clearContainer()
        const masterRow = document.createElement('div');
        masterRow.className = 'dpu-container-master-row';

        const row = document.createElement('div');

        row.className = 'dpu-row-table';
        row.innerHTML = `
        <div class="content-key">${obj.name}</div><div class ="dpu-arrow">${IconArrowTriangle()}</div>
        `;
        row.setAttribute('row-target-collapse', obj.id);

        masterRow.appendChild(row);
        const containerTable = document.createElement('div');
        containerTable.className = 'container-table';
        // Tạo bảng
        const table = document.createElement('table');
        table.className = 'info-table';

        // Tạo tbody
        const tbody = document.createElement('tbody');

        // Duyệt qua dữ liệu và thêm các hàng
        obj.properties.forEach((item: any) => {

            const row = document.createElement('tr');

            // Cột key
            const keyCell = document.createElement('td');
            keyCell.className = 'content-td content-td-key';
            keyCell.innerHTML = `<span class="key">${item.name}</span>`;

            // keyCell.textContent = item.name;
            row.appendChild(keyCell);

            // Cột value
            const valueCell = document.createElement('td');
            valueCell.className = 'content-td content-td-value';
            valueCell.innerHTML = `<span class="value">${item.value ? this._processValue(item.value, item.valueType) : ""}</span>`;

            // valueCell.textContent = this._processValue(item.value, item.valueType);
            row.appendChild(valueCell);
            // Cột value

            const unit = document.createElement('td');
            unit.className = 'content-td';
            unit.innerHTML = `<span class="unit">${item.unit || ""}</span>`;

            // unit.textContent = item.unit;
            row.appendChild(unit);
            // Thêm hàng vào tbody
            tbody.appendChild(row);

        });
        // Thêm sự kiện click để thay đổi lớp "open"
        row.addEventListener('click', () => {
            // Kiểm tra xem dòng có lớp "open" hay không và thay đổi
            masterRow.classList.toggle('open');
            if (masterRow.classList.contains('open')) {
                table.style.display = "none"
            } else {
                table.style.removeProperty('display')
            }

        });
        // Gắn tbody vào bảng
        containerTable.appendChild(table);
        table.appendChild(tbody);
        masterRow.appendChild(containerTable);
        this.containerDiv.appendChild(masterRow);




        return row
    }

    // Màu sắc gán
    //#region  pickDataElement
    private pickDataElement = () => {
        this.removeAllEvents();
        // Tạo handler cho sự kiện chuột
        this.handler = new ScreenSpaceEventHandler(this.viewer.canvas);

        const isClippingActiveAndRunning = () => {
            const clippingBtn = document.getElementById(`clipping-plane-${this.containerId}`);
            const lockBtn = document.getElementById(`clipping-plane-lock-gizmo-${this.containerId}`);
            if (clippingBtn && clippingBtn.classList.contains('active')) {
                if (!lockBtn || !lockBtn.classList.contains('active')) {
                    return true;
                }
            }
            return false;
        };

        //#region click
        this.handler.setInputAction((movement: any) => {
            if (isClippingActiveAndRunning()) return;

            this.objs = [];
            // Pick vật
            const picked = this.viewer.scene.pick(movement.position);
            //Kiểm tra file có thể pick để chuyển trang
            if (defined(picked)) {
                const entity = picked.id;
                if (entity) {
                    if (defined(entity.description)) {
                        const description = entity.description.getValue();
                        // Kiểm tra nếu mô tả chứa URL, lấy URL và mở trong cửa sổ mới
                        const urlMatch = description.match(/href="(.*?)"/);  // Tìm thẻ HTML chứa liên kết
                        if (urlMatch && urlMatch[1]) {
                            const url = urlMatch[1];
                            const userResponse = confirm("Bạn có muốn chuyển hướng đến trang web?");
                            if (userResponse) window.open(url, '_blank');  // Mở URL trong tab mới
                        }
                    }
                }
            }


            if (picked && picked instanceof Cesium3DTileFeature) {
                const compareColors = (c1: any, c2: any) => Object.keys(c1).every(key => c1[key] === c2[key]);

                const checkCompare = compareColors(picked?.color, colorIsolateCesium)
                if (!checkCompare) {
                    // Chọn đối tượng, lưu màu sắc gốc và đổi màu đối tượng đã chọn
                    this._handlePickedCesium(picked, false)
                } else {
                    const pickedObjects = this.viewer.scene.drillPick(movement.position);

                    for (const pickedObj of pickedObjects) {
                        if (pickedObj instanceof Cesium3DTileFeature) {
                            const isIsolate = compareColors(pickedObj?.color, colorIsolateCesium)
                            if (!isIsolate) {
                                this._handlePickedCesium(pickedObj, false)
                                break; // Thoát vòng lặp ngay khi gặp đối tượng phù hợp
                            }
                        }
                    }
                }

            } else {
                this._isCtrlLick = false
                this.listPicked = []
            }
            //Render lại tree sau click
            if (this.dialog) {
                this.dialog.innerBody = this.renderTableData();
            }
        }, ScreenSpaceEventType.LEFT_CLICK);
        //#region ctrl+click
        this.handler.setInputAction((movement: any) => {
            if (isClippingActiveAndRunning()) return;

            // Lấy vị trí pixel chuột
            const position = movement.position;
            const pickedCtrl = this.viewer.scene.pick(position);
            if (pickedCtrl instanceof Cesium3DTileFeature && pickedCtrl) {
                this._handlePickedCesium(pickedCtrl, true)

            }
            //Render lại tree sau click
            if (this.dialog) {
                this.dialog.innerBody = this.renderTableData();
            }

        }, ScreenSpaceEventType.LEFT_CLICK, KeyboardEventModifier.CTRL)
        //#region click+alt
        this.handler.setInputAction((movement: any) => {
            if (isClippingActiveAndRunning()) return;

            //Render lại tree sau click
            if (this.dialog) {
                this.objs = []
                this.dialog.innerBody = this.renderTableData();
            }

        }, ScreenSpaceEventType.LEFT_UP, KeyboardEventModifier.ALT)

        //Hủy sự kiện doubleClick
        this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(
            ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
    }
    private _isCtrlLick = false
    private _handlePickedCesium = (picked: any, ctrlPick: boolean = false) => {
        const targetProperty = picked.getProperty("Guid");

        if (!ctrlPick) {
            this._isCtrlLick = false
            this.listPicked = []


        } else {
            this._isCtrlLick = true

            // Tìm tất cả các đối tượng trong danh sách có Guid giống với đối tượng được chọn
            const elementsToRemove = this.listPicked.filter(
                (feature) => feature.guid === targetProperty
            );
            if (elementsToRemove.length > 0) {
                // Duyệt qua danh sách và xóa các phần tử có cùng Guid
                for (let i = this.listPicked.length - 1; i >= 0; i--) {
                    if (this.listPicked[i].guid === targetProperty) {
                        // Xóa phần tử khỏi listPicked
                        this.listPicked.splice(i, 1);
                    }
                }
                let checkOnlyItem = this._checkIfAllGuidAreTheSame()
                if (checkOnlyItem) {
                    this.objs = this.listPicked[0].objData
                    this._isCtrlLick = false

                }
                return

            }

        }


        try {

            // Lấy các thuộc tính từ feature
            const propertyKeys = picked.getPropertyIds();


            for (let i = 0; i < propertyKeys.length; i++) {
                const propertyKey = propertyKeys[i];
                let propertyValue = picked.getProperty(propertyKey);

                // Chuyển đổi tất cả giá trị về string
                if (propertyValue !== null && propertyValue !== undefined) {
                    propertyValue = propertyValue.toString();
                } else {
                    propertyValue = ""; // Gán giá trị mặc định nếu null hoặc undefined
                }


                this.objs.push({
                    name: propertyKey,
                    value: propertyValue
                });

            }
        } catch (error) {
            return
        }


        let objPicked = {
            feature: picked,
            guid: targetProperty, // Thêm trường guid (tuỳ chọn hoặc bắt buộc tuỳ vào logic)
            objData: this.objs
        }
        this.listPicked.push(objPicked)

        const content = (picked as any).content;
        for (let k = 0; k < content.featuresLength; k++) {
            if (k != picked.featureId) {
                const feature = content.getFeature(k);

                // console.log("feature",feature);
                const featureContentGuid = feature.getProperty("Guid")
                // console.log("featureContentGuid",featureContentGuid);

                if (featureContentGuid === targetProperty) {
                    let objPicked = {
                        feature: feature,
                        guid: featureContentGuid, // Thêm trường guid (tuỳ chọn hoặc bắt buộc tuỳ vào logic)
                        objData: this.objs
                    }
                    this.listPicked.push(objPicked);
                }
            }
        }

    }

    //Hủy hết sự kiện click, move,
    private removeAllEvents() {
        if (this.handler) {
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this.handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this.handler.removeInputAction(ScreenSpaceEventType.RIGHT_CLICK);
            this.handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK, KeyboardEventModifier.CTRL);
        }
    }



    private _checkIfAllGuidAreTheSame = (): boolean => {
        // Lấy tất cả các guid từ listPicked
        const guidSet = new Set(this.listPicked.map(item => item.guid));

        // Nếu chỉ có 1 guid duy nhất trong Set, tức là tất cả các guid đều giống nhau
        return guidSet.size === 1;
    };

    private _processValue = (value: string, valueType: string): string => {
        // if (valueType === "Float[3]") {
        //     // Tách chuỗi thành các phần tử riêng biệt
        //     const values = value.split(", ");

        //     // Làm tròn chỉ khi số có nhiều hơn 3 chữ số thập phân
        //     const roundedValues = values.map(v => {
        //         const floatValue = parseFloat(v);
        //         // Kiểm tra số chữ số thập phân của giá trị hiện tại
        //         const decimalPlaces = (v.split('.')[1] || '').length;

        //         // Nếu có hơn 3 chữ số thập phân thì làm tròn
        //         if (decimalPlaces > 3) {
        //             return floatValue.toFixed(3);
        //         }

        //         // Nếu đã có 3 chữ số thập phân, giữ nguyên
        //         return v;
        //     });

        //     // Trả về chuỗi đã làm tròn lại
        //     return roundedValues.join(", ");
        // }

        // Kiểm tra kiểu dữ liệu Double
        if (valueType === "Double") {
            const values = value.split(", ");
            const roundedValues = values.map(v => {
                const floatValue = parseFloat(v);
                // Kiểm tra phần thập phân
                const decimalPlaces = (v.split('.')[1] || '').length;

                if (decimalPlaces === 0) {
                    return v; // Nếu không có phần thập phân, giữ nguyên
                }

                return floatValue.toFixed(3); // Nếu có phần thập phân, làm tròn lên 3 chữ số
            });
            return roundedValues.join(", ");
        }
        return value;
    }

}